<template lang="pug">
v-container(justify-center )
    v-card(flat width="800px" class="rounded-card mx-auto" d-flex justify-center)
      v-form(v-model="valid" ref="form" lazy-validation @submit.prevent="saveConfiguration")
        v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
          template( v-slot:action="{attrs}")
            v-btn(text v-bind="attrs" @click="snackBar = false")
              v-icon fas fa-times
        v-container()
          v-combobox.pm-5( :loading="isFetchInProgress" :disabled="isFetchInProgress" v-model="selectedCustomer" outlined :items="customers1" item-value="id" item-text="name" :label="$t('settingsPage.selectCustomer')" append-icon="fas fa-chevron-down")
          v-switch.pb-3( :disabled="isFetchInProgress" :label="$t('settingsPage.allow_multiple_portions')" v-model="customerConfig.allow_multiple_portions")
          v-combobox.pb-3( outlined  :disabled="isFetchInProgress" append-icon="fas fa-chevron-down" :label="$t('settingsPage.available_portions_calculation_base')" :items="['all_reserved','active-only']" v-model="customerConfig.available_portions_calculation_base")
          v-switch.pb-3(:disabled="isFetchInProgress" :label="$t('settingsPage.allow_cross_top_menu_group')" v-model="customerConfig.allow_cross_top_menu_group")
          v-switch.pb-3( :disabled="isFetchInProgress" :label="$t('settingsPage.allow_reservation_note')" v-model="customerConfig.allow_reservation_note")
          v-switch.pb-3( :disabled="isFetchInProgress" :label="$t('settingsPage.show_boarder_card')" v-model="customerConfig.show_boarder_card")
          v-switch.pb-3( :disabled="isFetchInProgress" :label="$t('settingsPage.allow_rating_last_order')" v-model="customerConfig.allow_rating_last_order")
          v-text-field.pb-3( :rules="deliveryTimeDeltaRules" outlined  :disabled="isFetchInProgress"  :label="$t('settingsPage.last_order_rating_delivery_time_delta')" width="10px" append-icon="fas fa-pen"  v-model="customerConfig.last_order_rating_delivery_time_delta")
          v-row
          v-select(
            :items="tags"
            :label="$t('settingsPage.allow_show_price_for_tag')"
                  item-text="title"
                  item-value="id"
                  color="primary"
                  multiple
                  append-icon="fas fa-chevron-down"
                  chips
                  return-object
                  outlined
                  v-model="customerConfig.allow_show_price_for_tag"
                  :disabled="isFetchInProgress"
                )
                  template( v-slot:selection="{ item, index }")
                    v-chip
                      v-icon( small class="mr-2" ) fal {{ item.iconClass}}
                      span {{ item.title }}
                  template(v-slot:item="{active, item, attrs, on }")
                    v-list-item( v-on="on" v-bind="attrs" v-slot:default="{active}")
                      v-list-item-action
                        v-checkbox(
                            :input-value="active"
                            on-icon="fas fa-check-square"
                            off-icon="far fa-square" )
                        //v-row
                          //v-checkbox.pr-4( :input-value="active" :value="item.id" on-icon="fas fa-check-square" off-icon="far fa-square" )
                      v-list-item-content
                        v-list-item-title
                          v-icon(class="mr-5" ) {{ item.iconClass }}
                          span {{item.title}}
          v-card-actions
            v-spacer
            v-btn( color="primary" type="submit" :disabled="!valid" :loading="isFetchInProgress") {{$t('optOutDialog.submitCreditButtonLabel') }}
</template>
<script lang="ts">

/*
v-skeleton-loader(v-if="isFetchInProgress"
        type="list-item@12"
        width="100%")
*/ 
import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Tag from "@/model/tennant/Tag";
import { Action } from "vuex-class";
import {
  FETCH_BOARDER_DETAIL,
  FETCH_CUSTOMER_DATA,
  FETCH_TAGS
} from "@/store/action-types";
import CustomerModel from "@/model/customer/CustomerModel";
import axios from "@/plugins/axios";
import {defineStore} from 'pinia';
import { usePiniaStore } from "@/store/piniaStore";
import SettingsPage from "../SettingsPage.vue";

@Component({
  components: {},
})
export default class CustomerSettings extends Vue {
  private customers1: CustomerModel[] = [];
  private tags: Tag[] = [];
  selectedCustomer: CustomerModel | null = null;
  private manualCheckboxSelection: boolean = false
  private fetchInProgress: boolean = false
  private isFetchInProgress: boolean = false
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''
  private isValidNumber: boolean = false
  private valid: boolean = false

  private defaultConfig = {
    allow_multiple_portions: false,
    available_portions_calculation_base: "all_reserved",
    allow_cross_top_menu_group: false,
    allow_reservation_note: false,
    show_boarder_card: false,
    allow_rating_last_order: false,
    last_order_rating_delivery_time_delta: 48,
    allow_show_price_for_tag: [],
  };

  get customerConfig() {
    
    const config: any = this.selectedCustomer?.configuration;
    return {
      allow_multiple_portions:
        config?.allow_multiple_portions ??
        this.defaultConfig.allow_multiple_portions,
      available_portions_calculation_base:
        config?.available_portions_calculation_base ??
        this.defaultConfig.available_portions_calculation_base,
      allow_cross_top_menu_group:
        config?.allow_cross_top_menu_group ??
        this.defaultConfig.allow_cross_top_menu_group,
      allow_reservation_note:
        config?.allow_reservation_note ?? this.defaultConfig.allow_reservation_note,
      show_boarder_card:
        config?.show_boarder_card ?? this.defaultConfig.show_boarder_card,
      allow_rating_last_order:
        config?.allow_rating_last_order ??
        this.defaultConfig.allow_rating_last_order,
      last_order_rating_delivery_time_delta:
        config?.last_order_rating_delivery_time_delta ??
        this.defaultConfig.last_order_rating_delivery_time_delta,
      allow_show_price_for_tag:
        config?.allow_show_price_for_tag ??
        this.defaultConfig.allow_show_price_for_tag,
    };
  }
  
  get deliveryTimeDeltaRules(){
    return [
        (value: string | number) => {
          if(!value){
            return true;
          }
          this.isValidNumber = !isNaN(Number(value));
          return this.isValidNumber || this.$t("settingsPage.hourInNumber");
          
        },
    ];
  }
  
  @Action(FETCH_CUSTOMER_DATA) fetchData!: {
    (payload: any): Promise<CustomerModel[]>;
  };
  @Action(FETCH_TAGS) fetchTagList!: {(payload: any): Promise<Tag[]>};

  private pinniaStore = usePiniaStore();
  async fetchTags(): Promise<void>{
    try{
      const tagsResponse = await this.fetchTagList({payload: {}});
      this.tags = tagsResponse;
      console.log(tagsResponse);
    }catch(e){
      console.error(e);
    }
  }
  
  async getCustomersData(): Promise<void> {
    try {
      this.isFetchInProgress = true
      const response = await this.fetchData({ payload: {} });
      if (Array.isArray(response)) {
        this.customers1 = response as CustomerModel[];
        if (this.customers1.length > 0) {
          this.selectedCustomer = this.customers1[0];
        }
      } else {
        console.log("Unexpected response structure: ", response);
      }
    } catch (e) {
      console.log(e);
    }finally{
      this.isFetchInProgress = false;
    }
  }
  mounted() {
    this.getCustomersData();
    this.fetchTags();
  }
  //@Watch("selectedCustomer")

  getModifiedConfig(currentConfig: any, defaultConfig:any){
    const modifiedConfig: any = {};
    Object.keys(currentConfig).forEach(key => {
      if (currentConfig.hasOwnProperty(key) && currentConfig[key] !== defaultConfig[key]) {
        modifiedConfig[key] = currentConfig[key];
      }
  });

  return modifiedConfig;
  }
  async saveConfiguration() {
    if (this.selectedCustomer) {
      const customerId = this.selectedCustomer.id;
      const currentConfig = this.customerConfig;

      if (!currentConfig.last_order_rating_delivery_time_delta) {
        delete currentConfig.last_order_rating_delivery_time_delta;
      }
      const modifiedConfig = this.getModifiedConfig(currentConfig, this.defaultConfig);
      const config = { configuration: modifiedConfig };
      this.isFetchInProgress = true
      try {
        await this.pinniaStore.saveCustomerConfig(customerId,config);
        this.snackBar = true
        this.snackBarColor="success"
        this.snackBarMessage=this.$t('settingsPage.offerStructure.saved').toString()
        console.log(config);
        console.log("Configuration saved successfully");
        this.isFetchInProgress = false
      } catch (error) {
        this.snackBar = true
        this.snackBarColor ="error"
        this.snackBarMessage=this.$t('settingsPage.offerStructure.snackbarErrorSaveMessage').toString()
        console.error("Error saving configuration", error);
      }
      finally{
        this.fetchInProgress = false
      }
    }
  }
  
}


</script>
<style lang="stylus" scoped>

</style>
